// DS: i3.4
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const ArrowRight: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg width="0" height="0" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        d="M6.053 2.285l4.95 4.95a1 1 0 010 1.414l-4.95 4.95a1 1 0 01-1.414-1.414L8.881 7.94 4.64 3.7a1 1 0 011.414-1.414z"
        clipRule="evenodd"
      />
    </svg>
  </IconWrap>
);
ArrowRight.displayName = 'ArrowRight';

export default ArrowRight;
